var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.4882 9.14v2.9663a4.2843 4.2843 0 0 1 -4.173 4.2352h-6.6721a3.4077 3.4077 0 0 0 -3.34 3.3945v6.3607c0 1.81 1.5742 2.8751 3.34 3.3945a11.1762 11.1762 0 0 0 6.6721 0c1.6817-.4869 3.34-1.4668 3.34-3.3945v-2.5467h-6.6722v-.8486h10.0121c1.9414 0 2.6648-1.3542 3.34-3.3867a11.4642 11.4642 0 0 0 0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867zm-3.7526 16.1076a1.2731 1.2731 0 1 1 -1.2534 1.269 1.2607 1.2607 0 0 1 1.2534-1.269z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.7356 25.2476a1.2731 1.2731 0 1 1 -1.2534 1.269 1.2607 1.2607 0 0 1 1.2534-1.269z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.8351 2a19.0717 19.0717 0 0 0 -3.192.2725c-2.8268.4994-3.34 1.5447-3.34 3.4723v2.5461h6.68v.8491h-9.1869a4.1708 4.1708 0 0 0 -4.173 3.3867 12.4855 12.4855 0 0 0 0 6.7889c.4748 1.9776 1.6088 3.3867 3.55 3.3867h2.2968v-3.0523a4.2449 4.2449 0 0 1 4.173-4.15h6.6721a3.3654 3.3654 0 0 0 3.34-3.3944v-6.3606a3.729 3.729 0 0 0 -3.34-3.4723 20.8377 20.8377 0 0 0 -3.48-.2727zm-3.6125 2.0478a1.2731 1.2731 0 1 1 -1.2534 1.2768 1.2675 1.2675 0 0 1 1.2534-1.2768z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.2226 4.0478a1.2731 1.2731 0 1 1 -1.2534 1.2768 1.2675 1.2675 0 0 1 1.2534-1.2768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.5b929ed67c6543824987a15ca321acc9.svg";
export { ForwardRef as ReactComponent };